<template>
  <div>
    <!--- 内容页 -->
    <el-dialog
      :show-close="false"
      class="main-info"
      :visible.sync="visible"
      destroy-on-close
      :close-on-click-modal="false"
      v-if="showContent"
    >

         <p>
          <span class="back_icon" @click="visible=false"><i class="el-icon-arrow-left"></i>Back</span>
        </p>
         <p>Are you satisfied with the brand/product?</p>
        <div class="user-info" @click="clickBrand">
          <div><img :src="brandInfo['brandLogoUrl']"></div>
          <div>{{orderInfo['brandName']}}</div>
        </div>

        <div class="sub-content">
          <div class="rating-content">
            <p class="rating">
              <span>Product Quality</span>
              <el-rate class="cust-rating"  v-model="form['descriptionRating']"  void-color="#000" void-icon-class="el-icon-star-off" :show-text="true" :texts="disTxtRatings" :colors="colors" ></el-rate>
              <span v-if="vail['descriptionRating']">Please rate</span>
            </p>
            <p class="rating">
              <span>Brand Service</span>
              <el-rate class="cust-rating"  v-model="form['serviceRating']" void-color="#000" void-icon-class="el-icon-star-off" :show-text="true" :texts="disTxtRatings" :colors="colors"></el-rate>
              <span v-if="vail['serviceRating']">Please rate</span>
            </p>

            <p class="rating">
              <span>Logistics Rating</span>
              <el-rate class="cust-rating"  v-model="form['logisticsRating']" void-color="#000" void-icon-class="el-icon-star-off" :show-text="true" :texts="disTxtRatings" :colors="colors"></el-rate>
              <span v-if="vail['logisticsRating']">Please rate</span>
            </p>
          </div>
          <p class="add-review">Add review</p>
          <p class="add-review-textarea">
            <el-input  type="textarea"
                       show-word-limit
                       placeholder="Are you satisfied with the product? Can describe problems and help Brand improve" rows="5"
                       v-model="form['reviewContent']" maxlength="1000"
                       oninput="if(value.length>1000)value=value.slice(0,1000)">
           ></el-input>
            <span v-if="vail['reviewContent']">Please enter the review</span>
          </p>
          <p class="add-photo">Add a photo or video</p>
          <p class="add-photo-subtitle">Shoppers find images and videos more helpful than text alone.</p>
          <el-upload
            :action="uploadApi"
            ref="upload"
            list-type="picture-card"
            accept=".jpeg,.png,.jpg"
            :headers="headers"
            :limit="30"
            :file-list.sync="filelist"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"

          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-divider ></el-divider>
          <div class="img-list">
            <div ref="orderImgRef">
              <img :src="itm" v-for="(itm,i) in imgList">
            </div>
            <div class="more-img" @click="clickOrder">
              <span v-if="showMore">{{totalOrderImgCnt}}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <div class="submit" @click="submit">Submit</div>
     </el-dialog>
    <!-- 成功页（此处要求内容页app端全屏显示，而成功页不全屏显示，故单独冗余） -->
    <el-dialog
      :show-close="false"
      class="success-info"
      :visible.sync="visible"
      destroy-on-close
      :close-on-click-modal="false"
     v-else
    >
      <p>
        <span class="back_icon" @click="visible=false"><i class="el-icon-arrow-left"></i>Back</span>
      </p>
      <div class="review-success">
        <div></div>
        <p>Thanks for your review !</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, putAction, deleteAction, postAction } from '@/api/manage.js'

export default {
  components: {},
  props: {

  },
  data() {
    return {
      visible: false,
      showContent: true,
      showMore: false,
      uploadApi: '',
      index: -1,
      filelist: [],
      colors: ['#000000', '#000000', '#000000'],
      totalOrderImgCnt: 0, // 总共订单图片
      imgList: [],
      disTxtRatings: ['1.0', '2.0', '3.0', '4.0', '5.0'],
      form: {

      },
      vail: {
        descriptionRating: false,
        serviceRating: false,
        logisticsRating: false,
        reviewContent: false
      },
      brandInfo: {},
      orderInfo: {},
      headers: {
        'x-access-token': Vue.ls.get('token')
      }
    }
  },
  created() {
    this.loadBrand()

    this.uploadApi = process.env.API_URL + 'v0.2/orders/reviews/picture'
  },
  computed: {
    showH5App() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    }
  },
  watch: {
    form: {
      handler(n, o) {
        if (n['descriptionRating']) {
          this.vail['descriptionRating'] = false
        }
        if (n['serviceRating']) {
          this.vail['serviceRating'] = false
        }
        if (n['logisticsRating']) {
          this.vail['logisticsRating'] = false
        }
      },
      deep: true
    },
    orderInfo: {
      handler(n, o) {
        this.loadBrand()
      },
      deep: true
    }
  },
  methods: {
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(`Up to 30 files can be uploaded`)
    },
    show(orderInfo, index) {
      this.visible = true
      this.showContent = true
      this.orderInfo = orderInfo
      this.index = index

      // reset（重置data）
      this.form = this.$options.data().form

      this.imgList = this.orderInfo['orderDetails'].map(f => f['skuImg'])
      this.totalOrderImgCnt = this.imgList.length
      this.$nextTick(() => {
        let orderImgScrollHeight = this.$refs.orderImgRef.scrollHeight
        let orderImgClientHeight = this.$refs.orderImgRef.clientHeight
        if (orderImgScrollHeight > orderImgClientHeight && (orderImgScrollHeight - orderImgClientHeight) > 20) {
          this.showMore = true
        }
      })
    },
    async loadBrand() {
      let res = await getAction('/tsCollectionBrand/queryById', {
        id: this.orderInfo.brandId
      })
      if (res.result) {
        this.brandInfo = res.result
      }
    },
    clickBrand() {
      window.open(window.location.origin + '/brand' + this.orderInfo['brandSeoUrl'])
    },
    handleSuccess(response, file, fileList) {
      let url = response.result
      let fileName = url.substring(url.lastIndexOf('/') + 1)
      this.filelist.push({url: url, name: fileName})
    },
    handleRemove(file, fileList) {
      let newFiles = [...this.filelist]
      this.filelist = newFiles.filter(f => f.uid !== file.uid)
      this.removeImage(file)
    },
    removeImage(removeUrl) {
      const url = removeUrl.response ? removeUrl.response.result : removeUrl.url
      deleteAction('/common/image', { path: url }).then((response) => {
        if (response.success) {
          this.$message({
            message: 'successfully deleted!',
            type: 'success'
          })
        }
      })
    },
    clickOrder() {
      window.open(window.location.origin + '/whosalesDetails/' + this.orderInfo['orderId'])
    },
    async submit() {
      this.vail.descriptionRating = !this.form['descriptionRating']
      this.vail.serviceRating = !this.form['serviceRating']
      this.vail.logisticsRating = !this.form['logisticsRating']
      this.vail.reviewContent = !this.form['reviewContent']
      let flag = false
      for (let vailKey in this.vail) {
        if (this.vail[vailKey]) {
          flag = true
          break
        }
      }
      if (flag) {
        return
      }

      let obj = {
        content: this.form['reviewContent'],
        descriptionRating: this.form['descriptionRating'],
        logisticsRating: this.form['logisticsRating'],
        serviceRating: this.form['serviceRating'],
        attachmentList: this.filelist.map(f => f['url'])
      }
      let res = await postAction(`v0.2/orders/${this.orderInfo['orderId']}/reviews`, obj)
      if (res['success']) {
        this.showContent = false

        // 调用父方法，更新数据
        this.$parent.resetDataSourceItm(this.index)
      } else {
        this.$message.error(res['message'])
      }
    }

  }
}
</script>

<style lang="less" scoped>
.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  cursor: pointer;

}
.main-info{
  p,div{
    margin: 20px;
    position: relative;
  }
  p:nth-child(2){
    font-size: 16px;
  }
  .user-info{
    margin: 0 20px;
    position: relative;
    line-height: 45px;
    display: flex;
    justify-content: left;
    top: -15px;
    left: -20px;
    cursor: pointer;
    div:nth-child(1){
      width: 45px;
      height: 45px;
      border: 1px solid #E1E1E1;
      border-radius: 50%;
      background:#fff;
    }
    div:nth-child(2){
      margin-left: 2px;
    }
    div > img{
      border-radius: 50%;
    }
  }

  .sub-content{
    margin: 0px;
    height: 450px;
    top: -30px;
    overflow-y: auto;
  }

  .rating-content{
    position: relative;
    margin: 0px;
  }
  .rating{
    display: flex;
    .cust-rating{margin: 0px 20px;}
    span{
      display: inline-block;
      font-size: 14px;
      width: 110px;
    }
    span:nth-child(3){
      color: #F77073;
    }
  }
  .rating + label{
    display: inline-block;
    font-size: 14px;
    width: 110px;
    color: #F77073;
    margin: 10px 20px;
  }

  .add-review{
    top: -5px;
  }
  .add-review-textarea{
    top: -30px;
    width: 90%;
    .el-textarea{margin: 10px 0 5px;}
    span{color: #F77073;}
  }
  .add-photo{
    margin: 10px 20px;
    top: -40px
  }
  .add-photo-subtitle{color: #8F8F8F;margin-top: 0px;top: -50px;}
  .add-photo-subtitle + div{margin: 0px 20px;top: -60px ;}
  .el-divider{width: 90%;top: -60px}
  .img-list{
    top: -60px;
    display: flex;
    justify-content: left;
    height: 90px;
    overflow-y: hidden;
    div{margin: 0}
    img{width: 90px;height: 90px;margin-right: 10px;}
    .more-img{line-height: 45px;height: 45px;cursor: pointer;width: 90px;margin: 20px 0;}

  }
  .submit{
    top: -30px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #262B2F;
    font-family: Satoshi-Bold;
    color: #FFFFFF;
    cursor: pointer;
  }
}

.review-success{
  padding-top: 50px;
  p,div{
    margin: 0 auto;
  }

  div{
    width: 80px;
    height: 80px;
    background-image: url(https://master-shopvidi.s3.amazonaws.com/homepage-img/flower%402x.png);
    background-position: center center;
    background-size: cover;
  }
  p{
    margin-top: 20px;
    text-align: center;
    padding-bottom: 100px;
    font-family: Satoshi-Bold;
  }
}
/deep/ .el-rate__icon{margin-right: 5px;/*font-size: 15px;*/}
/deep/ .el-rate{width: 190px;}
/deep/ .el-icon-star-off{/*font-size: 15px !important;width: 15px;top: -0.5px;*/}
/deep/ .el-rate__text{margin-left: 12px;}

@media screen and (max-width: 600px) {
  .main-info /deep/ .el-dialog{
      width: 98% !important;
      min-height: 100vh !important;
      margin-top: -20px !important;
      margin-bottom: -25px !important;
  }
  .main-info{
    p,div{
      margin: 20px 10px;
    }
    .rating .cust-rating{
      margin: 0 10px !important;
    }
    .add-photo{
      margin: 10px !important;
    }
    .rating{
      /deep/ .el-rate__text{margin-left: 5px;}
      position: relative;
      span:nth-child(3){
        width: 80px !important;
        position: absolute;
        top: 18px;
      }
    }

    .sub-content{
      height: unset !important;
      overflow-y: unset;
    }
    .submit{
      top: -50px !important;
      margin: 0 10px 10px !important;
    }

  }

  .success-info /deep/ .el-dialog{
    width: 98% !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-review.vue